import React, { useEffect, useState } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion'
import Loader from '@components/loader/1'

const Faq = (props: RealEstateDataPageComponentData) => {
  const { title, subtitle, faqs } = props

  // Loader effect
  const [load, setLoad] = useState(true)
  useEffect(() => {
    setTimeout(() => {
      setLoad(() => false)
    }, 3000)
  }, [])

  return (
    <section
      id="faq-section"
      className={'faq p-y-config ' + (faqs?.length === 0 ? ' d-none' : '')}
    >
      <Container fluid>
        {!load ? (
          <>
            <Row>
              <Col xs={12}>
                <h2 className="section-title pb-lg-5">{title}</h2>
              </Col>
              <Col xs={12}>
                <h3 className="section-subtitle pb-lg-3">{subtitle}</h3>
              </Col>
            </Row>
            <div className="faqs-wrapper my-4">
              <Accordion flush>
                {faqs && faqs?.length > 0
                  ? faqs?.map((qa, i) => (
                      <Accordion.Item eventKey={String(i)}>
                        <Accordion.Header as={'div'}>
                          <h3>{qa.question}</h3>
                        </Accordion.Header>
                        <Accordion.Body className="px-0">{qa.answer}</Accordion.Body>
                      </Accordion.Item>
                    ))
                  : null}
              </Accordion>
            </div>
          </>
        ) : (
          <Loader />
        )}
      </Container>
    </section>
  )
}

export default Faq
